import React, { Component } from "react";
import Vimeo from "./vimeo";
import ReactPlayer from "react-player/lazy";

import styles from "./project-single.module.scss";
import theme from "../styles/theme.module.scss";

class App extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    url: this.props.row.videos[0].videoFull.link,
    paddingTop: 100 / this.props.row.videos[0].videoFull.aspectRatio + "%",
    pip: false,
    playing: false,
    controls: true,
    light: false,
    volume: 0.8,
    muted: false,
    playbackRate: 1.0,
    loop: false,
  };

  load = (url) => {
    this.setState({
      url,
      playing: true,
      played: 0,
      loaded: 0,
      pip: false,
    });
  };

  renderLoadButton = (url, label) => {
    return <button onClick={() => this.load(url)}>{label}</button>;
  };

  ref = (player) => {
    this.player = player;
  };

  render() {
    const {
      url,
      playing,
      controls,
      light,
      volume,
      muted,
      loop,
      played,
      loaded,
      duration,
      playbackRate,
      paddingTop,
      pip,
    } = this.state;
    const SEPARATOR = " · ";
    const divStyle = {
      paddingTop: this.state.paddingTop,
    };
    const pT = this.props.row.noTopPadding ? "" : "pT6";
    const pB = this.props.row.noBottomPadding ? "" : "pB6";

    return (
      <div
        className={[
          styles.row,
          theme.gdcont,
          theme.gmcont,
          theme[pT],
          theme[pB],
          styles[this.props.type],
        ].join(" ")}
        style={{ backgroundColor: `${this.props.bgColor}`, color: `${this.props.textColor}` }}
      >
        <div className={`${styles.fullVideo} ${theme.gdmain} ${theme.gmfull}`}>
          <div className={`${theme.playerWrapper} ${this.props.className}`} style={divStyle}>
            <ReactPlayer
              ref={this.ref}
              className={`${theme.reactPlayer}`}
              width="100%"
              height="100%"
              url={url}
              pip={pip}
              playing={playing}
              controls={controls}
              light={light}
              loop={loop}
              volume={volume}
              muted={muted}
            />
          </div>
        </div>
        {this.props.row.videos.length > 1 && (
          <>
            <ul
              className={`${styles.videoLoops} ${theme.fdcont} ${theme.fmcont} ${theme.gdmain} ${theme.gmmain}`}
            >
              {this.props.row.videos.map((value, key) => {
                const url = value.videoFull.link;
                const loopUrl = value.videoLoop.link;
                const paddingTop = 100 / value.videoFull.aspectRatio + "%";
                const divStyle = {
                  paddingTop: paddingTop,
                };

                return (
                  <li
                    onClick={() => this.load(url)}
                    className={`${styles.videoLoop} ${theme.fd3} ${theme.fm2}`}
                    key={key}
                  >
                    <button className={`${styles.videoLink}`} aria-label="Play Video">
                      <span>Play</span>
                    </button>
                    <div
                      className={`${theme.playerWrapper} ${this.props.className}`}
                      style={divStyle}
                    >
                      <ReactPlayer
                        className={`${theme.reactPlayer}`}
                        width="100%"
                        height="100%"
                        url={loopUrl}
                        playing={true}
                        controls={false}
                        loop={true}
                        muted={true}
                      />
                    </div>
                  </li>
                );
              })}
            </ul>
          </>
        )}
      </div>
    );
  }
}

export default App;
